import React, { useState } from 'react';
import { Modal, Box, Typography, TextField, Button } from '@mui/material';
import { showToastAlert } from "../../admin/components/CustomAlert";
import { addCompany } from "../../services/writerPost";
import { useSelector } from 'react-redux';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 300,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};


export function CompanyModal({ open, onClose, onCreate }) {
    const [companyName, setCompanyName] = useState('');
    const [logoPath, setLogoPath] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const token = useSelector(state => state.token);

    React.useEffect(() => {
      setCompanyName("");
      setLogoPath("");
    }, []);

    const handleCreate = async () => {
      if (!companyName.trim()) return;
      setError(null);
      try {
        const response = await addCompany(token, companyName, logoPath);
        if(response.status !== 200) {
          showToastAlert(response.data.message, "error");
          return;
        }
        onCreate();
        onClose();
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
  
    return (
      <Modal open={open} onClose={onClose}>
        <Box sx={style}>
          <Typography variant="h6" component="h2" gutterBottom>
            New Company
          </Typography>
          <TextField
            label="Company Name"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
          label="Logo Path"
          value={logoPath}
          onChange={(e) => setLogoPath(e.target.value)}
          fullWidth
          sx={{ mb: 2 }}
        />
          {error && <Typography color="error" sx={{ mb: 1 }}>{error}</Typography>}
          <Button variant="contained" onClick={handleCreate} fullWidth>Create</Button>
        </Box>
      </Modal>
    );
  }
  